<template>
  <div>
    <loader v-if="isLoading" />
    <page404 v-else-if="!It" />
    <main
      className="mb-10"
      v-else
    >
      <!--
      sale_available
      price_from
      yabilet
    -->
      <sale
        v-if="It.yabilet || It.sale_available || It.price_from"
        :it="It"
      />
      <is-free
        v-else
        :it="It"
      />

      <!-- <PreData class="my-10">{{ It }}</PreData> -->
      <div v-if="It.yabilet || It.sale_available || It.price_from">
        <section class="mb-6 mt-10">
          <h2
            class="lg:w-3/3 mb-8"
            style="font-size: larger;font-weight: 700;"
          >
            Другие события
          </h2>
        </section>
        <section class="lg:w-3/3">
          <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <card-event
              v-for="It in list"
              :key="It.id"
              :it="It"
            />
          </div>
        </section>
      </div>
      <div v-else>
        <section class="max-w-620px mx-auto mb-6 mt-10">
          <h2
            className="lg:w-3/3 mb-8"
            style="font-size: larger;font-weight: 700;"
          >
            Другие события
          </h2>
        </section>
        <section class="max-w-620px mx-auto lg:w-3/3">
          <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <card-event
              v-for="It in list"
              :key="It.id"
              :it="It"
            />
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import CardEvent from '@/components/CardEvent.vue';
// import PreData from "@/components/PreData.vue";

import IsFree from '@/views/IsFree.vue';
import Sale from '@/views/Sale.vue';
import Page404 from './Page404';
import Loader from '../components/Loader.vue';
export default {
  name: 'Item',
  components: {
    // PreData,
    IsFree,
    Sale,
    CardEvent,
    Page404,
    Loader
  },
  data() {
    return {
      It: null,
      list: [],
      isLoading: true
    };
  },
  watch: {
    $route: 'getData'
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const getParams = {};
      try {
        const [ItRes] = await Promise.all([
          this.$axios.get(`/afisha/events/${this.$route.params.id}`)

        ]);
        this.It = ItRes.data.data;
        if (this.It) {
          getParams.sessions_from = this.$dayjs().format('YYYY-MM-DD');
          getParams.sessions_to = this.$dayjs().add(3, 'month').format('YYYY-MM-DD');
          getParams.type_id = this.It.type.id;
          getParams.per_page = 4;

          const [listRes] = await Promise.all([
            this.$axios.get('afisha/events', { params: getParams })
          ]);
          // чтобы Item не совпала
          this.list = listRes.data.data
            .filter(news => Number(news.id) !== Number(this.$route.params.id) && this.It.type.id == news.type.id)
            .slice(0, 3);
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    }
  }
};
</script>
<style scoped>
.grids {
  grid-template-columns: repeat(2,minmax(0,1fr));
  display: grid;
  grid-gap: 2rem;
  gap: 2rem;
}
</style>
